import axios from '../../../utils/axios';
import { createSlice } from '@reduxjs/toolkit';

const LOGIN_API_URL = `${process.env.REACT_APP_BASE_URL}/auth/signin`;
const VERIFY_OTP_API_URL = `${process.env.REACT_APP_BASE_URL}/auth/verify-email`;

const TOKEN_STORAGE_KEY = 'loginToken';
const USER_DATA = 'user-data';

const initialState = {
  token: localStorage.getItem(TOKEN_STORAGE_KEY),
};

// POST: https://apptest.arkchat.com/v1/admin/auth/verify-email
// {
//     "email": "rohit@sukritinfotech.com",
//     "otp": 123456,
//     "signIn": true
// }

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.token = action.payload.token;
      localStorage.setItem(TOKEN_STORAGE_KEY, action.payload.token);
      localStorage.setItem(USER_DATA, JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.token = null;
      localStorage.removeItem(TOKEN_STORAGE_KEY);
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;


export const signIn = (body) => async (dispatch) => {
  try {
    const SIGNIN_API_URL = `${process.env.REACT_APP_BASE_URL}/auth/register`;
    const response = await axios.post(SIGNIN_API_URL, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.data.status) {
      return response.data;
    } else {
      return response.data;
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const login = (body) => async (dispatch) => {
  try {
    const response = await axios.post(LOGIN_API_URL, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.data.status) {
      localStorage.setItem('email', body?.email);
      return response.data;
    } else {
      return response.data;
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const verifyOtp = (body) => async (dispatch) => {
  try {
    const response = await axios.post(VERIFY_OTP_API_URL, body, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (response.data.status) {
      dispatch(loginSuccess(response.data.data));
      return response.data;
    } else {
      return response.data;
    }
  } catch (err) {
    throw new Error(err);
  }
};

export const logoutUser = () => async (dispatch) => {
  try {
    await dispatch(logout());
    localStorage.clear();
  } catch (err) {
    throw new Error(err);
  }
};

export default authSlice.reducer;
